// extracted by mini-css-extract-plugin
export default {"Details":"styles_Details__JCX6P","buttons":"styles_buttons__04PHr","container":"styles_container__ACTH8"};